<div class="toast toast-end toast-bottom">
    @for (toast of toastService.toasts(); track toast.id) {
        <div role="alert" class="alert alert-soft alert-{{ toast.type }}">
            <span class="whitespace-pre-line">{{ toast.message }}</span>
            <button class="btn btn-ghost btn-xs" (click)="toastService.dismiss(toast.id)">✕</button>
        </div>
    }
</div>

<!-- DON'T DELETE, THIS FOR POST CSS -->
<div class="hidden">
    <div class="alert-success"></div>
    <div class="alert-info"></div>
    <div class="alert-warning"></div>
    <div class="alert-error"></div>
</div>
